import * as Sentry from "@sentry/react";

const FLUSH_TIMEOUT_MS = 2000;

type Flush = (timeout: number) => Promise<boolean>;

const sentryFlush: Flush = (timeout) => Sentry.flush(timeout);

/** A closing webview may skip `visibilitychange`, so `pagehide` flushes the buffered logs too. */
export const flushSentryOnPageHide = (flush: Flush = sentryFlush): void => {
  window.addEventListener("pagehide", () => {
    void flush(FLUSH_TIMEOUT_MS);
  });
};
